import { EMAIL_TEMPLATES, type UpdateQueueSettingsInput } from '@easyhelp/shared';
import Divider from '@mui/material/Divider';
import { Fragment } from 'react';
import type { Control } from 'react-hook-form';
import { EmailTemplateFields } from './EmailTemplateFields';
import { SettingsSection } from './SettingsSection';

export interface EmailTemplatesSectionProps {
  control: Control<UpdateQueueSettingsInput>;
}

/** Testi delle email automatiche: un template per la notifica di assegnazione e uno per la chiusura. */
export function EmailTemplatesSection({ control }: EmailTemplatesSectionProps) {
  return (
    <SettingsSection
      id="queue-settings-templates"
      title="Testi delle email automatiche"
      description="Sono le parole che il destinatario legge. I segnaposto fra graffe vengono sostituiti all’invio."
    >
      {EMAIL_TEMPLATES.map((template, index) => (
        <Fragment key={template.key}>
          {index > 0 && <Divider />}
          <EmailTemplateFields template={template} control={control} />
        </Fragment>
      ))}
    </SettingsSection>
  );
}
